// extracted by mini-css-extract-plugin
export const portfolio = "resumes-module--portfolio--3ZNT6";
export const resumes = "resumes-module--resumes--Z_P_t";
export const resume = "resumes-module--resume--zyYo2";